import apiClient from './apiClient';

export interface TestListingRow {
  WorkOrderDetailKey: string;
  TestStatus: string;
  SpecimenRef: string;
  SpecimenDepth: number | null;
  CheckedBy: string | null;
  TestDate: string | null;
  ReviewedBy: string | null;
  ReviewDate: string | null;
  ApprovedBy: string | null;
  ApprovalDate: string | null;
  SampleId: string;
  SampleReference: string;
  SampleType: string;
  DepthTop: number | null;
  DepthBase: number | null;
  LocationId: string;
  LocationName: string;
  TestName: string;
  /** Stable dispatch slug (BUG-2026-0197); null when the test has no code. */
  TestCode: string | null;
  WorkOrderId: string;
  WorkOrderKey: string;
  ProjectId: string;
  ProjectName: string;
  ProjectKey: string;
  /** Latest active quote converted into this project (null when none). */
  QuoteNumber: string | null;
  sysLastModifiedDate: string;
}

export async function getAllTests(params?: { status?: string; search?: string }): Promise<TestListingRow[]> {
  const query = new URLSearchParams();
  if (params?.status) query.set('status', params.status);
  if (params?.search) query.set('search', params.search);
  const { data } = await apiClient.get(`/workorders/tests?${query.toString()}`);
  return data;
}
